import { useCallback, useEffect, useState } from "react";
import useChangeEmail from "@/domains/playerMenu/hooks/useChangeEmail";
import useGetCodeTimer from "@/domains/playerMenu/hooks/useGetCodeTimer";
import PlayerMenuSettingsSafetyConfirmNewEmail from "@/domains/playerMenu/components/settings/safety/changeEmail/PlayerMenuSettingsSafetyConfirmNewEmail";

type Props = {
  newEmail: string;
  onConfirm: () => void;
};
export default function PlayerMenuSettingsSafetyConfirmNewEmailContainer({
  onConfirm,
  newEmail,
}: Props) {
  const [code, setCode] = useState("");
  const { checkCodeHandler, checkError, checkIsCompleted, checkIsPending, sendNewCodeHandler } =
    useChangeEmail();

  const { getTimer, timer } = useGetCodeTimer();

  useEffect(() => {
    getTimer({ type: "email", payload: newEmail });
  }, []);

  const onSubmit = useCallback(() => {
    checkCodeHandler(code);
  }, [code, checkCodeHandler]);

  useEffect(() => {
    if (checkIsCompleted && !checkError) {
      onConfirm();
    }
  }, [checkError, checkIsCompleted, onConfirm]);

  const onSendCode = useCallback(async () => {
    await sendNewCodeHandler(newEmail);
    await getTimer({ type: "email", payload: newEmail });
  }, [newEmail]);

  return (
    <PlayerMenuSettingsSafetyConfirmNewEmail
      onSubmit={onSubmit}
      code={code}
      onChangeCode={setCode}
      onSendCode={onSendCode}
      pending={checkIsPending}
      sendIsPending={false}
      address={newEmail}
      error={checkError}
      timer={timer}
    />
  );
}
